var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M13.563-9.937A1.447,1.447,0,0,1,14-8.875V-.5A1.447,1.447,0,0,1,13.563.563,1.447,1.447,0,0,1,12.5,1H1.5A1.447,1.447,0,0,1,.438.563,1.447,1.447,0,0,1,0-.5v-11a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-13H9.875a1.447,1.447,0,0,1,1.063.438ZM5.578-1.578A1.933,1.933,0,0,0,7-1a1.933,1.933,0,0,0,1.422-.578A1.933,1.933,0,0,0,9-3a1.933,1.933,0,0,0-.578-1.422A1.933,1.933,0,0,0,7-5a1.933,1.933,0,0,0-1.422.578A1.933,1.933,0,0,0,5-3,1.933,1.933,0,0,0,5.578-1.578ZM10-10.531a.36.36,0,0,0-.125-.25l-.094-.094A.36.36,0,0,0,9.531-11H2.375A.331.331,0,0,0,2-10.625v3.25A.331.331,0,0,0,2.375-7h7.25A.331.331,0,0,0,10-7.375Z",
    transform: "translate(0 13)",
    fill: "#2a66bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.dbb7fc508ac5d52f53fecb4a651463b1.svg";
export { ForwardRef as ReactComponent };